import React from 'react'
import Psd2Eps from './providers/EPS'
import Psd2Stripe from './providers/Stripe'
import {Psd2Ppn} from './providers/noop'
import {ServerCode} from './types'

type Psd2Provider = typeof Psd2Eps | typeof Psd2Stripe | typeof Psd2Ppn

export const Psd2IframeRef = React.createRef<HTMLIFrameElement>()

class Psd2 {
  static serverCode: ServerCode
  private static provider: Psd2Provider

  private constructor() {}

  public static getProvider(providerCode?: ServerCode) {
    if (this.provider) return this.provider
    this.serverCode = providerCode
    switch (providerCode) {
      case ServerCode.Eps:
        this.provider = Psd2Eps
        break
      case ServerCode.Stripe:
      case ServerCode.Hbd:
      case ServerCode.Wbd:
        this.provider = Psd2Stripe
        break
      case ServerCode.Ppn:
        this.provider = Psd2Ppn
        break
    }

    return this.provider
  }
}

export default Psd2
